import React from 'react';
import { AwardIcon, CheckIcon, LockIcon, ShieldCheckIcon, ZapIcon } from 'lucide-react';
import { Button } from './ui/Button';
import { checkoutUrl, included, price, priceBefore, productShortName, totalBonuses, totalVolumes } from '../data/offer';
export function PricingSection() {
  return <section id="pricing" className="scroll-mt-4 bg-white py-16 sm:py-24" aria-labelledby="pricing-title" data-id="element-160" data-mp="1j9gzgtubtlbh">
      <div className="mx-auto max-w-3xl px-4" data-id="element-161" data-mp="1nbbuxhpkt4hc">
        <h2 id="pricing-title" className="text-center text-3xl font-extrabold text-navy sm:text-4xl" data-id="element-162" data-mp="1ncmyphj0uc8g">
          Choose your option
        </h2>

        <article className="mt-10 overflow-hidden rounded-2xl border border-line bg-white shadow-lift" data-id="element-163" data-mp="1x8glruud9o4h">
          <div className="h-2 w-full bg-solar" aria-hidden="true" data-id="element-164" data-mp="2282zs6i0r8ec" />
          <div className="p-6 sm:p-10" data-id="element-165" data-mp="2up54bdme3zj">
            <span className="inline-flex items-center gap-2 rounded-full bg-navy px-3 py-1.5 text-[11px] font-extrabold uppercase tracking-[.16em] text-white" data-id="element-166" data-mp="2vqr3aw6caw1">
              <AwardIcon className="h-3.5 w-3.5 text-solar" aria-hidden="true" data-id="element-167" data-mp="1mgogxhl8plni" /> Main offer
            </span>

            <div className="mt-5 flex flex-col gap-6 border-b border-line pb-7 sm:flex-row sm:items-end sm:justify-between" data-id="element-168" data-mp="1hpg4sdsizm6n">
              <div data-id="element-169" data-mp="1crwo778cuxbj">
                <h3 className="font-display text-2xl font-extrabold leading-tight text-navy" data-id="element-170" data-mp="1cr4uk1ybj9nw">{productShortName}</h3>
                <p className="mt-2 text-sm text-muted" data-id="element-171" data-mp="17ppbgffpbd85">
                  All {totalVolumes} volumes + {totalBonuses} exclusive bonuses ready to use in your classroom.
                </p>
              </div>
              <div className="sm:text-right" data-id="element-172" data-mp="20ems6e49l1ys">
                <span className="text-sm text-muted" data-id="element-173" data-mp="1vgbhk165anfi">
                  Regular price <span className="line-through" data-id="element-174" data-mp="1rg1b6nefxv04">{priceBefore}</span>
                </span>
                <p className="mt-1 font-display text-5xl font-extrabold text-navy" data-id="element-175" data-mp="k27px1n15bdm">{price}</p>
                <p className="text-xs font-extrabold uppercase tracking-[.16em] text-leafDark" data-id="element-176" data-mp="g0m42qsipmra">Today · 50% discount</p>
              </div>
            </div>

            <ul className="mt-7 grid gap-2.5 sm:grid-cols-2" data-id="element-177" data-mp="hj2w8w7ly3dq">
              {included.map(item => <li key={item} className="flex items-start gap-2.5 text-sm leading-snug text-navy" data-id="element-178" data-mp="mgcik2zp9yxc">
                  <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-leaf" aria-hidden="true" data-id="element-179" data-mp="7j29t1efz75b" />
                  {item}
                </li>)}
            </ul>

            <Button href={checkoutUrl} target="_blank" rel="noopener noreferrer" arrow className="mt-9 w-full" data-id="element-180" data-mp="3uwegmn13n3vx">
              Get my teacher ready now
            </Button>

            <div className="mt-6 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs font-semibold text-muted" data-id="element-181" data-mp="3kyqh7jsjt87f">
              <span className="inline-flex items-center gap-1.5" data-id="element-182" data-mp="3px1opnvdf6mh">
                <LockIcon className="h-4 w-4 text-leaf" aria-hidden="true" data-id="element-183" data-mp="3pv8gw590ugcw" /> Secure payment
              </span>
              <span className="inline-flex items-center gap-1.5" data-id="element-184" data-mp="3fzdssum13t2q">
                <ZapIcon className="h-4 w-4 text-leaf" aria-hidden="true" data-id="element-185" data-mp="3fylxlkwcfxcz" /> Instant access
              </span>
              <span className="inline-flex items-center gap-1.5" data-id="element-186" data-mp="2xd7idjtkzqjs">
                <ShieldCheckIcon className="h-4 w-4 text-leaf" aria-hidden="true" data-id="element-187" data-mp="2sdbkm2bh8vco" /> 7-day guarantee
              </span>
            </div>
            <p className="mt-4 text-center text-xs text-muted" data-id="element-188" data-mp="369f34ycznf9b">
              You pay in USD. Your payment platform automatically shows the conversion to your local currency.
            </p>
          </div>
        </article>
      </div>
    </section>;
}